import { DefaultQueryParams, isMobile, parseQuery } from '@pascal/pascal-core';

export const gameResourceNames = {
  background: 'background',
  character: 'character',
  fishPopup: 'fishPopup',
  transition: 'transition',
  marlinFish: 'marlin',
};

export const webGameResources = {
  background: {
    name: gameResourceNames.background,
    path: 'spines/main/background/web/background.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/main/background/web/background.atlas',
      },
    },
  },
  character: {
    name: gameResourceNames.character,
    path: 'spines/main/character/web/character.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/main/character/web/character.atlas',
      },
    },
  },
  fishPopup: {
    name: gameResourceNames.fishPopup,
    path: 'spines/main/fishPopup/web/fishPopup.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/main/fishPopup/web/fishPopup.atlas',
      },
    },
  },
  // transition: {
  //   name: gameResourceNames.transition,
  //   path: 'spines/main/transition/web/transition.json',
  //   config: {
  //     metadata: {
  //       spineAtlasFile: 'spines/main/transition/web/transition.atlas',
  //     },
  //   },
  // },
};

export const mobileGameResources = {
  background: {
    name: gameResourceNames.background,
    path: 'spines/main/background/mobile/background.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/main/background/mobile/background.atlas',
      },
    },
  },
  character: {
    name: gameResourceNames.character,
    path: 'spines/main/character/mobile/character.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/main/character/mobile/character.atlas',
      },
    },
  },
  fishPopup: {
    name: gameResourceNames.fishPopup,
    path: 'spines/main/fishPopup/mobile/fishPopup.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/main/fishPopup/mobile/fishPopup.atlas',
      },
    },
  },
  // transition: {
  //   name: gameResourceNames.transition,
  //   path: 'spines/main/transition/mobile/transition.json',
  //   config: {
  //     metadata: {
  //       spineAtlasFile: 'spines/main/transition/mobile/transition.atlas',
  //     },
  //   },
  // },
};

const brandedGameMobileAnimation = {};

const brandedGameWebAnimation = {};

const checkedResourcesByGameId = () => {
  const { [DefaultQueryParams.GameId]: gameId } = parseQuery(window.location.search);
  const gameResources = [];

  if (isMobile()) {
    gameResources.push(brandedGameMobileAnimation[gameId] || mobileGameResources);
  } else {
    gameResources.push(brandedGameWebAnimation[gameId] || webGameResources);
  }

  return gameResources;
};

export const gameResources = checkedResourcesByGameId();
